import { useState } from 'react';
import { useDeleteAiLearning } from '../../../hooks/queries/aiQueries';
import ChevronDownIcon from '../../../assets/icons/chevron-down.svg?react';
import ChevronLeftIcon from '../../../assets/icons/chevron-left.svg?react';
import DeleteIcon from '../../../assets/icons/delete.svg?react';
const AiLearningTableRow = ({ 
  aiLearningRecordSysId,
  IsReLearnRequest,
  baseAlgorithm, 
  version, 
  aiModelType, 
  IterationCount, 
  startTime, 
  endTime, 
  status,
  statusColor,
  requestedAt,
  completedAt,
  logDetails
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const deleteAiLearning = useDeleteAiLearning();

  const handleDelete = async () => {
    if (window.confirm('이 학습 요청을 삭제하시겠습니까?')) {
      try {
        await deleteAiLearning.mutateAsync(aiLearningRecordSysId);
      } catch (error) {
        console.error('삭제 실패:', error);
        alert('삭제 중 오류가 발생했습니다.');
      }
    }
  };

  const aiModelTypeConvert = (aiModelType) => {
    switch (aiModelType) {
      case 'ChargingDemandPrediction': return '충전량 예측 AI 모델';
      case 'CblPrediction': return 'CBL 예측 AI 모델';
      default: return aiModelType;
    }
  }

  return (
    <>
      <tr>
        <td>
          <button
            className="expand-button"
            onClick={() => setIsExpanded(!isExpanded)}
            aria-label={isExpanded ? '접기' : '펼치기'}
          >
            {isExpanded ? <ChevronDownIcon style={{ transform: 'rotate(-180deg)', transition: 'transform 0.2s ease' }} /> : <ChevronDownIcon style={{ transition: 'transform 0.2s ease' }} />}
          </button>
        </td>
        <td>
          <span className={`status-badge ${IsReLearnRequest ? 'warning' : 'success'}`}>
            {IsReLearnRequest ? '재학습' : '신규학습'}
          </span>
        </td>
        <td>
          <span className={`status-badge unknown`}>
            {aiModelTypeConvert(aiModelType) || '-'}
          </span>
        </td>
        <td>{requestedAt || '-'}</td>
        <td>{completedAt || '-'}</td>
        <td>{baseAlgorithm || '-'}</td>
        <td>{version || '-'}</td>
        <td>{IterationCount ?? '-'}</td>
        <td>
        <div className="flex align-center gap-2">
            <p>{startTime || '-'}</p>
            <p className="text-center">~</p>
            <p>{endTime || '-'}</p>
          </div>
        </td>
        <td>
          <span className={`status-badge ${statusColor}`}>
            {status}
          </span>
        </td>
        <td width="40px">
          <button className="btn icon-btn" onClick={handleDelete} disabled={deleteAiLearning.isPending}>
            <DeleteIcon color='var(--gray-600)'/>
          </button> 
        </td>
      </tr>
      {isExpanded && (
        <tr className="ai-learning-table-row-expanded">
          <td colSpan="11" className="bg-gray-200">
            <div className="flex flex-col gap-4">
              <p className="text-b2-700 text-gray-400">로그 상세</p>
              {logDetails && (
                <div className="detail-section">
                  <div className="log-details">
                    <pre>{typeof logDetails === 'string' ? logDetails : JSON.stringify(logDetails, null, 2)}</pre>
                  </div>
                </div>
              )}
            </div>
          </td>
        </tr>
      )}
    </>
  );
};

export default AiLearningTableRow;